import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { handleLogout } from '../utils/handleLogout';
import { Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { calculateTotalLikes, calculateTotalPrompts, formatCreatedAt, formatDate, formatFollowers, getOptimizedImage } from '../utils/Universalfunctions';
import ShareSection from './ShareSection';
import SEO from '../config/SEO';
import { db } from '../utils/firebase';
import { collection, getDocs } from 'firebase/firestore';
import { currency, shortLogo } from '../config/config';
import { Favorite, GeneratingTokens, Upload } from '@mui/icons-material';
import { useUser } from '../context/UserContext';
import { getPlanIcon } from '../utils/DynamicUniversalFunctions';
import DailyReward from '../componets/DailyReward';

const AccountInfo = () => {

     const ITEMS_PER_PAGE = 10;

     const { userData, followersCount, followingCount, isPremium } = useUser();
     const [currentPage, setCurrentPage] = useState(1);
     const [prompts, setPrompts] = useState([]);



     useEffect(() => {
          const fetchPrompts = async () => {
               const querySnapshot = await getDocs(collection(db, "prompts"));
               const list = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

               // Filter prompts by current user ID
               const rawUID = userData?.uid || JSON.parse(localStorage.getItem("userID"));
               const newresult = list.filter(item => item.userId === rawUID);

               // Update state with filtered prompts
               setPrompts(newresult.reverse());
          };

          fetchPrompts();
     }, [userData?.uid]);



     // pagination calculations
     const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
     const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

     const currentPrompts = prompts.slice(indexOfFirstItem, indexOfLastItem);

     const totalPages = Math.ceil(prompts.length / ITEMS_PER_PAGE);


     return (
          <>
               <SEO
                    title="My Account"
                    description="Manage your profile, prompts and settings."
               />


               <section className="account-page">
                    <div className='__container'>
                         <div className="row">

                              <DailyReward db={db} userData={userData} />

                              <div className='col-lg-8'>
                                   {userData?.subscriptions === "paid" &&
                                        <div className="row mb-4">
                                             <div className="col-md-3 col-6">
                                                  <div className="__top-new-cards">
                                                       <h6>Subscription Purchased</h6>
                                                       <p>
                                                            {userData?.planDetails?.planTimestamp ? new Date(userData?.planDetails?.planTimestamp).toLocaleDateString() : "N/A"}
                                                       </p>
                                                  </div>
                                             </div>

                                             <div className="col-md-3 col-6">
                                                  <div className="__top-new-cards">
                                                       <h6>Subscription Plan Name</h6>
                                                       <p>{userData?.planDetails?.planTitle || "Free Plan"}</p>
                                                  </div>

                                             </div>

                                             <div className="col-md-3 col-6">
                                                  <div className="__top-new-cards">
                                                       <h6>Subscription Status</h6>
                                                       <p className={userData?.subscriptions === "paid" ? "active" : "expired"}>
                                                            {userData?.subscriptions?.toLocaleUpperCase() || "FREE"}
                                                       </p>
                                                  </div>
                                             </div>

                                             <div className="col-md-3 col-6">
                                                  <div className="__top-new-cards">
                                                       <h6>Expiry Date</h6>
                                                       <p>
                                                            {formatDate(userData?.planDetails?.expiryAt)}
                                                       </p>
                                                  </div>
                                             </div>
                                        </div>
                                   }


                                   <div className="welcome-box">
                                        <div className="welcome-header">
                                             <span className="tag">Welcome Back , {userData?.name || 'User'}</span>
                                             <h2>Keep inspiring the gallery</h2>
                                             <p>
                                                  Share your first prompt to teach the community how you unlock
                                                  cinematic frames.
                                             </p>
                                             {userData?.subscriptions === 'cancel_user' && <p className='text-warning mt-3' > ⚠️ {userData?.name} {userData?.subscriptionMessage} </p>}
                                             {userData?.message && <p className='text-warning' style={{ marginTop: '10px' }}> {userData?.message} </p>}
                                        </div>

                                        {userData?.subscriptions !== "paid" &&
                                             <div className="free-user-box mb-4">
                                                  {userData?.subscriptions === 'payment_pending' ?
                                                       <p className='text-warning'>📢  Verifying your payment... This usually takes a few minutes. </p>
                                                       :
                                                       <p>
                                                            Upgrade your <strong>HeyPrompt</strong> account to unlock more opportunities.
                                                            Share your best prompts or digital items, grow your audience,
                                                            and start earning from your creativity.
                                                            Premium members get better visibility and extra features to help them grow faster.
                                                       </p>}

                                                  <div className="free-user-links">
                                                       <Link to="/pricing?subscription" className="pricing-link">View Pricing</Link>
                                                       <Link to="/marketplace" className="upgrade-link">Upgrade Now</Link>
                                                  </div>
                                             </div>
                                        }

                                        <div className="row stats-row">
                                             <div className="col-sm-4 col-4">
                                                  <div className="stat-card">
                                                       <h3> <GeneratingTokens fontSize='10' style={{ marginTop: '-5px' }} />  {formatFollowers(userData?.generation_credits)} </h3>
                                                       <p>Generation Credits</p>
                                                  </div>
                                             </div>


                                             <div className="col-sm-4 col-4">
                                                  <div className="stat-card">
                                                       <h3>{currency}{userData?.totalEarnings || 0}</h3>
                                                       <p>Total Points </p>
                                                  </div>
                                             </div>

                                             <div className="col-sm-4 col-4">
                                                  <div className="stat-card">
                                                       <h3>0</h3>
                                                       <p>Withdrawable</p>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="action-row">
                                             {userData?.subscriptions === "paid" && <Link to="/marketplace" className="btn-main">Monetization</Link>}
                                             <Link to="/gallery" className="btn-secondary">Explore community feed</Link>
                                             <span className="last-update">Last update :- <br /> {userData?.lastSignIn || '-'}</span>
                                        </div>
                                   </div>



                              </div>


                              <div className="col-12 col-lg-4">
                                   <div className={`profile-box ${isPremium ? 'premium-box' : ''}`}>
                                        <div className="profile-info">
                                             <div>
                                                  <img src={userData?.photoURL || shortLogo} alt="User Avatar" /> <br />
                                             </div>
                                             <div>
                                                  <h5>{userData?.name || 'User'}
                                                       {userData?.isPremium && (
                                                            <OverlayTrigger
                                                                 placement="top"
                                                                 overlay={
                                                                      <Tooltip id="plan-tooltip">
                                                                           {userData?.planDetails?.planTitle} Plan Active
                                                                      </Tooltip>
                                                                 }
                                                            >
                                                                 <span className='d-inline-block ms-1'>{getPlanIcon(userData?.planDetails?.planTitle)}</span>
                                                            </OverlayTrigger>
                                                       )}
                                                  </h5>
                                                  <p className="email">{userData?.email || 'user@example.com'}</p>
                                                  <p className="signed-as">{userData?.username || 'Loading...'}</p>
                                             </div>
                                        </div>

                                        <div className="stats-row">
                                             <div className="stat-box">
                                                  <p>{userData?.prompt || 0}</p>
                                                  <h6>Post</h6>
                                             </div>

                                             <div className="stat-box">
                                                  <p>{followersCount || 0}</p>
                                                  <h6>Followers</h6>
                                             </div>

                                             <div className="stat-box">
                                                  <p>{followingCount || 0}</p>
                                                  <h6>Following</h6>
                                             </div>
                                        </div>

                                        <div className="profile-stats">
                                             <div>
                                                  <p>Member since</p>
                                                  <span>{userData?.createdAt || 'N/A'}</span>
                                             </div>
                                        </div>

                                        <div className="like-info">
                                             <Favorite /> <span>{userData?.about || 'Welcome! Explore the latest community prompts.'}</span>
                                        </div>

                                        <div className="buttons">
                                             <Link to="/submit" className="btn-main"> <Upload /> Submit new prompt </Link>
                                             <button onClick={() => handleLogout('/login')} type='button' className="btn-secondary">Sign out</button>
                                        </div>
                                   </div>
                              </div>

                              <div className="col-12">
                                   <div className="prompt-library">
                                        <h4>Prompt Library</h4>
                                        <p>
                                             {userData?.prompt === 0 ?
                                                  "You have not published any prompts yet. Upload your first artwork to get started." :
                                                  `${userData?.name || 'Dear'} Your prompts are now available for others to browse.`}
                                        </p>


                                        <div className="prompt-stats">
                                             {calculateTotalPrompts(prompts) &&
                                                  <>
                                                       <span className='pending'>Pending Prompts: {calculateTotalPrompts(prompts).totalPending || 0}</span>
                                                       <span className='success'>Success Prompts: {calculateTotalPrompts(prompts).totalSuccess || 0}</span>
                                                  </>
                                             }
                                             <span>Total likes: {formatFollowers(calculateTotalLikes(prompts)) || 0}</span>


                                        </div>




                                        <div className="prompt-accordion-wrap">
                                             {prompts && prompts.length > 0 ? (
                                                  <Accordion>
                                                       {currentPrompts.map((item, i) => (
                                                            <Accordion.Item eventKey={i.toString()} key={i} className="prompt-item">
                                                                 <Accordion.Header>
                                                                      <div className="prompt-header">
                                                                           <div style={{ display: 'flex', gap: '10px' }}>
                                                                                <img src={`https://res.cloudinary.com/dvlqi71yj/image/upload/w_1200,c_limit,f_auto,q_auto/l_My%20Brand:apple-touch-icon_npxiql,w_70,o_50/fl_layer_apply,g_south_east,x_20,y_20/${item?.imageUrl}`} alt={item?.title} style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                                                                                <div>
                                                                                     <h3 className="prompt-title">{item?.title}</h3>
                                                                                     <p>
                                                                                          {item?.category}  - {Array.isArray(item?.tags) ? item.tags.join(", ") : typeof item?.tags === "string" ? item.tags : "N/A"}
                                                                                     </p>
                                                                                </div>
                                                                           </div>
                                                                           <div className="status-section">
                                                                                <span className="prompt-status public">{formatFollowers(item?.likes) || 0} Likes</span>
                                                                                <span className={`prompt-status ${item?.visibility === "public" ? "public" : "private"}`}>{item?.visibility || "Public"}</span>
                                                                                <span className={`prompt-status ${item?.status === "success" ? "success" : "pending"}`}>{item?.status || "Success"}</span>
                                                                           </div>
                                                                      </div>
                                                                 </Accordion.Header>
                                                                 <Accordion.Body>
                                                                      <div className="prompt-details">
                                                                           <div className="prompt-content">
                                                                                <div className='row'>
                                                                                     <div className='col-12'>
                                                                                          <div className='__badge'>
                                                                                               <span> {formatCreatedAt(item?.createdAt)} </span>
                                                                                               <span> {item?.bookmarks || 0} bookmarks  </span>
                                                                                               <span> {item?.promptSource || '-'}  </span>
                                                                                          </div>

                                                                                          <h6 className='label'>prompt</h6>
                                                                                          <p>{item?.promptText}</p>
                                                                                          <Link to={getOptimizedImage({ publicId: item?.imageUrl })} className='btn-view-image' target='_blank' > View Image </Link>


                                                                                          <ShareSection url={`${window.location.origin}/prompts/${item?.id}`} />
                                                                                     </div>

                                                                                     {/* <div className='col-md-5 d-none'>
                                                                                          <div className='__img-previw'>
                                                                                               <img src={getOptimizedImage({ publicId: item?.imageUrl || shortLogo })} alt={item?.title} />
                                                                                          </div>
                                                                                     </div> */}
                                                                                </div>

                                                                           </div>
                                                                      </div>
                                                                 </Accordion.Body>
                                                            </Accordion.Item>
                                                       ))}
                                                  </Accordion>
                                             ) : (
                                                  <div className="no-data">
                                                       <p>No prompts published yet 😔</p>
                                                  </div>
                                             )}

                                             {totalPages > 1 && (
                                                  <div className="pagination-wrap mt-5">

                                                       <button
                                                            disabled={currentPage === 1}
                                                            onClick={() => setCurrentPage(prev => prev - 1)}
                                                            className="page-btn"
                                                       >
                                                            Prev
                                                       </button>

                                                       <span className="page-info">
                                                            Page {currentPage} of {totalPages}
                                                       </span>

                                                       <button
                                                            disabled={currentPage === totalPages}
                                                            onClick={() => setCurrentPage(prev => prev + 1)}
                                                            className="page-btn"
                                                       >
                                                            Next
                                                       </button>

                                                  </div>
                                             )}
                                        </div>

                                   </div>
                              </div>
                         </div>
                    </div>
               </section>

          </>
     );
}

export default AccountInfo;